import { OneGateLogo_2Icon } from "@dataone/icons";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

interface DesktopFallbackProps {
  children?: React.ReactNode;
}

const DesktopFallback = ({ children }: DesktopFallbackProps) => {
  const containerRef = useRef(null);
  const [isDesktop, setDesktop] = useState(true);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries && entries[0]) {
        const { contentRect } = entries[0];
        setDesktop(contentRect.width < 900 ? false : true);
      }
    });

    containerRef.current && resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <span
        ref={containerRef}
        style={{ position: "absolute", width: "100%" }}
      />
      {isDesktop ? (
        children
      ) : (
        <StyledDesktopFallback>
          <OneGateLogo_2Icon />
          <h3>
            Optimal utilization of Onegate is achieved when employing larger
            screens.
          </h3>
          <p>
            Please allow the completion of our app's operation for an enhanced
            mobile experience.
          </p>
          <div />
        </StyledDesktopFallback>
      )}
    </>
  );
};

export default DesktopFallback;

const StyledDesktopFallback = styled.div`
  height: 100vh;
  position: relative;
  svg {
    font-size: 115px;
    display: flex;
    margin: 0px 30px;
  }

  h3 {
    max-width: 265px;
    margin: 10px 30px 20px;
  }

  p {
    max-width: 265px;
    margin: 0px 30px;
    font-size: 13px;
  }

  > div {
    background-image: url(images/profile/guest.webp);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0.6;
    z-index: -1;
  }
`;
